import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Integration 2 Article Page
 */
const Integration2 = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Integration 2</h1>
                <p className="article-subtitle">
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Configuration</h2>
                  <p className="article-section-intro">
                    Ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam.
                  </p>
                </div>

                <div className="article-subsection">
                  <h3 className="article-subsection-title">API Setup</h3>
                  <p className="article-subsection-description">
                    Nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.
                  </p>
                  <ul className="article-list-dots">
                    <li>
                      <strong>API Key:</strong> Vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? At vero eos et accusamus et iusto odio dignissimos ducimus.
                    </li>
                    <li>
                      <strong>Webhooks:</strong> Qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.
                    </li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Integration 1',
                  route: getHelpRoute(getHelpArticleRoute('integrations', 'integration-1'))
                }}
                next={{
                  title: 'Integration 3',
                  route: getHelpRoute(getHelpArticleRoute('integrations', 'integration-3'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Integration2;
